import {
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Component } from '@angular/core';
import { DxPopupComponent } from 'devextreme-angular';
import { ParametriPasswords } from '../../utils/ildato-gestione-password/parametri-passwords';
import { AggiornaPasswordModel } from '../../utils/ildato-gestione-password/aggiorna-password-model';
import { IlDatoAggiornaPasswordComponent } from '../../utils/ildato-gestione-password/ildato-aggiorna-password/ildato-aggiorna-password.component';

@Component({
  selector: 'app-popup-password-scaduta',
  templateUrl: './popup-password-scaduta.component.html',
  styleUrls: ['./popup-password-scaduta.component.scss'],
  imports: [DxPopupComponent, IlDatoAggiornaPasswordComponent],
  standalone: true,
})
export class PopupPasswordScadutaComponent {
  @Input() username: string;
  @Input() parametriPasswords: ParametriPasswords;
  @Output() popupPasswordScadutaEventEmitter =
    new EventEmitter<AggiornaPasswordModel>();

  onIlDatoAggiornaPasswordEvent(event) {
    this.popupPasswordScadutaEventEmitter.emit(event);
  }
}
